import PropTypes from 'prop-types';
import { applyImportantStyles } from '../../lib';
import './DesktopHorizontalTooltipContent.css';

export const DesktopHorizontalTooltipContent = ({
    content,
    poweredBy,
    CustomLogo,
    LogoUrl,
}) => {
    return (
        <div className="ab-desktop-horizontal-tooltip ab-booking-widget-box-shadow">
            <div dangerouslySetInnerHTML={{ __html: content }}></div>
            <div className="ab-desktop-horizontal-tooltip-powered-by">
                <span
                    ref={(el) => {
                        applyImportantStyles(el, {
                            'font-size': '12px',
                            color: 'black',
                        });
                    }}
                >
                    Powered by &nbsp;
                </span>
                <a href={LogoUrl} target="_blank" rel="noopener noreferrer">
                    <img
                        src={CustomLogo}
                        alt="Logo"
                        style={{ width: '70px' }}
                        ref={(el) => {
                            applyImportantStyles(el, {
                                display: 'unset',
                                float: 'unset',
                            });
                        }}
                    />
                </a>
            </div>
        </div>
    );
};

DesktopHorizontalTooltipContent.propTypes = {
    content: PropTypes.string,
    CustomLogo: PropTypes.string,
    LogoUrl: PropTypes.string,
    poweredBy: PropTypes.shape({
        logo: PropTypes.string,
        url: PropTypes.string,
    }),
};
